
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.625 7.5a4.877 4.877 0 00-4.869 4.627.75.75 0 01-.564.69 2.252 2.252 0 00.558 4.433h1.5a.751.751 0 010 1.5h-1.5A3.75 3.75 0 013 15c0-1.56.952-2.895 2.304-3.457a6.376 6.376 0 0111.79-2.445 4.874 4.874 0 01-.969 9.652h-.375a.751.751 0 010-1.5h.375a3.373 3.373 0 003.375-3.375 3.381 3.381 0 00-2.972-3.352.755.755 0 01-.576-.398A4.879 4.879 0 0011.625 7.5zm-.155 3.967a.75.75 0 011.06 0l2.25 2.25a.75.75 0 11-1.06 1.065l-.97-.975V18a.751.751 0 01-1.5 0v-4.193l-.97.976a.75.75 0 11-1.06-1.066l2.25-2.25z"}})])
          )
        }
      }
    